module.exports = __webpack_public_path__ + "img/oneGreen.a2da3c92.jpg";